import { render } from "./SegmentosInstView.vue?vue&type=template&id=fb2c1394&scoped=true"
import script from "./SegmentosInstView.vue?vue&type=script&lang=js"
export * from "./SegmentosInstView.vue?vue&type=script&lang=js"

import "./SegmentosInstView.vue?vue&type=style&index=0&id=fb2c1394&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb2c1394"]])

export default __exports__